import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.search.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import delay from 'lodash/delay';
import SearchDataProvider from '~/components/specific/Providers/SearchDataProvider.vue';
import { TIMER } from '~/const/timers';
import '@web/shared-digital-library/icons/svg-originals/loupe.svg';
import '@web/shared-digital-library/icons/svg-originals/micro.svg';
import '@web/shared-digital-library/icons/svg-originals/cross.svg';
import registerStoreModule from '~/helpers/store-helper';
import pageActions from '~/store/modules/pageActions';
var SearchResultsModal = function SearchResultsModal() {
  return import('./SearchResultsModal.vue');
};
export default {
  name: 'SearchItem',
  components: {
    SearchResultsModal: SearchResultsModal,
    SearchDataProvider: SearchDataProvider
  },
  props: {
    hasStickedFilters: {
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    return {
      searchInputLoading: true,
      searchError: false,
      search: '',
      results: {
        products: [],
        total: 0
      },
      searchResults: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    provider: 'search/provider'
  })), {}, {
    formAction: function formAction() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/q/").concat(this.sanitizedSearch);
    },
    sanitizedSearch: function sanitizedSearch() {
      return this.search ? this.search.trim().replace(/[()<>[\]{}"/\\;=?.]/gi, '') : '';
    }
  }),
  watch: {
    value: function value() {
      if (this.type === 'search' && this.value === true && this.$refs.search !== undefined) {
        this.focus();
      }
      if (this.type === 'search' && !this.value) {
        this.resetForm();
      }
    }
  },
  created: function created() {
    registerStoreModule(this.$store, 'pageActions/', pageActions);
  },
  mounted: function mounted() {
    var _this = this;
    this.$root.$on('close-search-results', function () {
      if (_this.searchResults) {
        setTimeout(function () {
          _this.searchResults = false;
        }, 100);
      }
    });
    this.searchInputLoading = false;
  },
  destroyed: function destroyed() {
    this.$root.$off('close-search-results');
  },
  methods: {
    openSearch: function openSearch() {
      var _this$ABTests;
      this.searchResults = true;
      var tracking = {
        data: _objectSpread({
          event_category: 'Header',
          event_action: 'Search',
          event_label: "Clic"
        }, ((_this$ABTests = this.ABTests) === null || _this$ABTests === void 0 ? void 0 : _this$ABTests.products) && {
          test_name: this.ABTests.products.id,
          test_version: this.ABTests.products.variantID
        })
      };
      this.$root.$emit('generic-tracking', null, tracking);
    },
    focusSearchInput: function focusSearchInput() {
      var _this2 = this;
      delay(function () {
        return _this2.$refs.search.focus();
      }, 50);
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this,
        _this$ABTests2;
      if (this.search === '') {
        this.searchError = true;
        delay(function () {
          _this3.searchError = false;
        }, TIMER);
      }
      this.$root.$emit('generic-tracking', null, {
        data: _objectSpread({
          event_category: 'Header',
          event_action: 'Search',
          event_label: "Entr\xE9e_".concat(this.search)
        }, ((_this$ABTests2 = this.ABTests) === null || _this$ABTests2 === void 0 ? void 0 : _this$ABTests2.products) && {
          test_name: this.ABTests.products.id,
          test_version: this.ABTests.products.variantID
        })
      });
      window.location.assign(this.formAction);
      this.resetForm();
      this.$refs.search.blur();
      this.$emit('submitCloseMenu');
      if (this.isAlgoliaProvider) {
        localStorage.setItem('algolia-tracking-index', this.getAlgoliaProductIndex);
      }
    },
    handleInput: function handleInput(_ref) {
      var target = _ref.target;
      this.search = target.value;
      this.searchResults = true;
    },
    handleArrowUp: function handleArrowUp() {
      this.$refs.searchResults.focusLastItem();
    },
    handleArrowDown: function handleArrowDown() {
      this.$refs.searchResults.focusFirstItem();
    },
    handleLeaveViewSuggestion: function handleLeaveViewSuggestion() {
      this.$emit('hide-search-banner');
      this.resetForm();
      this.$root.$emit('hide-layer');
    },
    goToSearch: function goToSearch() {
      this.$root.$emit('hide-layer');
      this.$router.push(this.formAction);
      this.resetForm();
    },
    resetForm: function resetForm() {
      this.search = '';
      this.searchError = false;
      this.results = {
        products: [],
        total: 0
      };
    },
    updateSearchValue: function updateSearchValue(keyword) {
      this.search = keyword;
    },
    saveABTests: function saveABTests(_ref2) {
      var ABTests = _ref2.ABTests;
      this.ABTests = ABTests;
    }
  }
};